import React from 'react';
import { FieldType } from 'types/FieldTypes';
import FormModal from 'components/modals/FormModal';
import { useSettingsDivision } from 'components/settings/SettingsDivisionContext';
import EmailDomainVerificationModal from './EmailDomainVerificationModal';
import { useModal } from 'components/modals/ModalContext';

// Rename the name of the function:
const EmailDomainForm: React.FC<{ viewKey?: string }> = ({ viewKey }) => {

    // Prefill the division with the division selected in the settings menu
    const { selectedDivision, isEnvironmentSelected } = useSettingsDivision();
    const divisionDefaultValue = !isEnvironmentSelected && selectedDivision ? { value: String(selectedDivision.id) } : undefined;
    const { initializeModal } = useModal();

    const apiObject = 'email_domain'

    // Plug in the fields and their properties:
    const fields: FieldType[] = [
        {
            name: 'default_from_email',
            label: 'email.email_domain.default_from_email_label',
            type: 'email',
            placeholder: 'email.email_domain.default_from_email_placeholder',
            helperText: 'email.email_domain.default_from_email_helperText',
        },
        {
            name: 'division',
            defaultValue: divisionDefaultValue,
            label: 'email.email_domain.division_label',
            type: 'dropdown',
            disabled_selected: 'email.email_domain.select_division_disabled_selected',
            showSearch: false,
            apiRequest: [{
                endpoint: 'get_division_list',
                object: 'division',
                params: { is_active: true },
                useCache: true
            }],
            allowNoneOption: false,
            activeFeature: 'divisions'
        },
    ];

    // Handle opening of the verification modal
    const handleOpenVerificationModal = (data: any) => {
        initializeModal(<EmailDomainVerificationModal itemId={data.id} />, {
            modalSize: 'large'
        });
    };
    
    return (
        <FormModal 
            viewKey={viewKey}
            apiObject={apiObject}
            fields={fields}
            onSuccess={handleOpenVerificationModal}
        />
    );
};

export default EmailDomainForm;